import { Receipt, TrendingUp, Gem, ShieldCheck } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const CARDS = [
  { key: "trasparente", Icon: Receipt, title: "Modello Trasparente", text: "Nessuna fee sulle assunzioni, abbonamento annuale fisso." },
  { key: "futuro", Icon: TrendingUp, title: "Investire nel futuro", text: "Monitora i talenti dal banco di scuola all'ingresso nel mondo del lavoro, dati a disposizione per 36 mesi." },
  { key: "qualita", Icon: Gem, title: "Qualità, non quantità", text: "Analisi reale delle attitudini per scegliere chi meglio si adatta alle tue esigenze." },
  { key: "fiducia", Icon: ShieldCheck, title: "Fiducia", text: "Un team dedicato che ti guida con massima professionalità, rispetto e trasparenza." },
];

export const PercheProdigy = () => (
  <section className="relative px-6 py-20 lg:py-36" data-testid="perche-section">
    <div className="max-w-6xl mx-auto">
      <Reveal className="mb-14 lg:mb-20">
        <h2 className="font-extrabold tracking-[-0.04em] leading-[1] text-4xl sm:text-5xl lg:text-6xl">Perché scegliere Prodigy?</h2>
      </Reveal>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {CARDS.map(({ key, Icon, title, text }, i) => (
          <Reveal key={key} delay={(i % 2) * 120} className="h-full">
            <article className="why-card glass glass-light h-full rounded-[24px] p-8 sm:p-10" data-testid={`why-card-${key}`}>
              <Icon className="h-7 w-7 text-cyan" strokeWidth={1.4} />
              <h3 className="mt-8 font-bold tracking-[-0.025em] text-2xl">{title}</h3>
              <p className="mt-3 text-base text-titanium leading-relaxed">{text}</p>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
